import { BackArrow, SaveIcon } from "allIcons";
import { useParams } from "react-router-dom";
import {
  MainButton,
  AddComponent,
  SecondaryHeading,
  RightMainContainer,
  PrimaryHeading,
  PreviewCard,
  InputField,
  IconWrapper,
  HeaderContainer,
  TextEditor,
  BodyContainer,
  DeleteButton,
} from "commonUI";

export default function AddEditCourse() {
  const { id } = useParams();

  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <IconWrapper>
            <BackArrow />
            <PrimaryHeading>[Course Title]</PrimaryHeading>
          </IconWrapper>
          <div className="flex items-center justify-center gap-14">
            <DeleteButton
              show={id !== "add"}
              deleteMessage="You are about to delete Content Request Item from your account. This
                action cannot be undone! All settings related to the WP Site
                Launcher Content Request Item will permanently removed. Do you wish to
                proceed and delete the Content Request Item?"
            />
            <MainButton>
              <SaveIcon />
              Save Changes
            </MainButton>
          </div>
        </HeaderContainer>
        <BodyContainer>
          <InputField label="Title" placeholder="Write Title Here" />
          <InputField
            label="Video URL"
            placeholder="Write Video URL Here"
            labelClass="font-semibold"
          />
          <TextEditor label="Description" editorClass="mt-2" height={100} />
          <div className="mt-2">
            <SecondaryHeading>Tags</SecondaryHeading>
            <div className="flex items-center gap-5">
              <PreviewCard
                color="#F12424"
                title="Tag 1"
                icon={true}
                className="m-0"
              />
              <PreviewCard
                color="#7846FF"
                title="Tag 2"
                icon={true}
                className="m-0"
              />
              <PreviewCard
                color="#2EA3F2"
                title="Tag 3"
                icon={true}
                className="m-0"
              />
            </div>
          </div>
          <AddComponent />
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
